import React from 'react'
import {
    CircularProgress,
    Container,
} from "@material-ui/core";
import {BookingHeader} from "../../shared/header";
import Slider from "react-slick";
import {inject, observer} from "mobx-react";
import Error404 from "../../shared/404";
import Rating from "@material-ui/lab/Rating";

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const sliderSettings = {
    dots: true,
    infinite: true,
    demo: 0,
    speed: 100,
};

const ExpandableRoomDescription = ({description}) => {
    const [expanded, setExpanded] = React.useState(false);
    const [hasOverflow, setHasOverflow] = React.useState(false);
    const descriptionRef = React.useRef(null);
    const mobileQuery = '(max-width: 767px)';

    React.useEffect(() => {
        const measureDescription = () => {
            const descriptionElement = descriptionRef.current;
            if (!descriptionElement) {
                return;
            }
            if (!window.matchMedia(mobileQuery).matches) {
                setExpanded(false);
                setHasOverflow(false);
                return;
            }

            const wasExpanded = descriptionElement.classList.contains('room-description-expanded');
            descriptionElement.classList.remove('room-description-expanded');
            setHasOverflow(descriptionElement.scrollHeight > descriptionElement.clientHeight + 1);
            if (wasExpanded) {
                descriptionElement.classList.add('room-description-expanded');
            }
        };

        measureDescription();
        window.addEventListener('resize', measureDescription);

        return () => {
            window.removeEventListener('resize', measureDescription);
        };
    }, [description]);

    return (
        <div
            ref={descriptionRef}
            className={'room-description full-width room-description-collapsible'
                + (expanded ? ' room-description-expanded' : '')
                + (hasOverflow ? ' room-description-has-overflow' : '')}
            onClick={() => hasOverflow && setExpanded(!expanded)}
        >
            {description}
        </div>
    );
};

const BookingStudioPageIndex = inject('bookingStudioPageStore')(observer(({bookingStudioPageStore}) => {
    bookingStudioPageStore.load();
    if (bookingStudioPageStore.bookingServiceType === 'muztorg') {
        document.body.style.backgroundColor = "transparent";
        document.getElementById('root').style.backgroundColor = "transparent";
    }
    return (
        bookingStudioPageStore.is404 ?
            <Error404 hideBackground={bookingStudioPageStore.bookingServiceType === 'muztorg'}/> :
            <Container className="booking-page studio-page"
                       style={bookingStudioPageStore.bookingServiceType !== 'muztorg' ? {} : {backgroundColor: 'transparent'}}>
                {bookingStudioPageStore.loading ?
                    <CircularProgress color="secondary" className="loader"/> :
                    <div>
                        <div>
                            <BookingHeader
                                appUrlSuffix={bookingStudioPageStore.studio ? bookingStudioPageStore.studio.header_utm_suffix : ''}
                                useLogoUrl={bookingStudioPageStore.bookingServiceType !== 'muztorg'}
                                buttonText={'История заказов'}
                                buttonCallback={bookingStudioPageStore.clickHistoryButton}
                            />
                            {bookingStudioPageStore.studio
                                ?
                                <h2 className="studio-name">{bookingStudioPageStore.studio.name}</h2>
                                : ''}
                            <div className="booking-studio-rooms">
                                {
                                    bookingStudioPageStore.rooms ?
                                        bookingStudioPageStore.rooms.map((room, key) =>
                                            <div className="one-room-info" key={room.id || key}>
                                                {
                                                    room.hot_offer ?
                                                        <div className="hot-offer-text">{room.hot_offer.text}</div>
                                                        : ''
                                                }
                                                <div className="room-poster" style={{width: "100%"}}>
                                                    <Slider
                                                        {...sliderSettings}
                                                    >
                                                        {room.photos.map((slideImage, index) => (
                                                            <div key={index}>
                                                                <img alt="poster" className="room-poster-image"
                                                                     src={(process.env.NODE_ENV === 'development' ? 'http://tonesky.ru' : '') + '/' + slideImage.url}/>
                                                            </div>
                                                        ))}
                                                    </Slider>
                                                </div>
                                                <div className="room-rating-block">
                                                    <div className="one-room-rating">
                                                        <Rating
                                                            name="rating-stars"
                                                            className="rating-stars"
                                                            defaultValue={parseFloat(room.rating.averange)}
                                                            precision={0.1}
                                                            max={5}
                                                            readOnly
                                                            size="large"/>
                                                        <div className="rating-value">
                                                            {room.rating.averange > 0 ? room.rating.averange : 'нет оценок'}
                                                        </div>
                                                    </div>
                                                    <div></div>
                                                </div>
                                                <div className="room-title full-width">
                                                    {room.name}
                                                </div>
                                                <ExpandableRoomDescription description={room.description}/>
                                                <div className="room-address-and-hours full-width">
                                                    <div className="room-address">
                                                        <img alt="room-address-icon"
                                                             src={(process.env.NODE_ENV === 'development' ? 'http://tonesky.darlane' : '') + '/images/icons/map-tag.svg'}/>
                                                        <a href={room.map_url}
                                                           target="_blank"><span>{room.address}</span></a>
                                                    </div>
                                                    <div className="room-hours">
                                                        <img alt="room-hours-icon"
                                                             src={(process.env.NODE_ENV === 'development' ? 'http://tonesky.darlane' : '') + '/images/icons/clock.svg'}/>
                                                        <span style={{whiteSpace: 'pre-wrap'}}>{room.work_hours}</span>
                                                    </div>
                                                </div>
                                                <div className="room-bottom-block">
                                                    <div className="one-room-price">от {room.min_price ?? 0} руб.</div>
                                                    <div className="room-heart-block"
                                                         onClick={bookingStudioPageStore.clickRoomFavButton.bind(this, room)}>
                                                        <img alt="room-heart-icon"
                                                             className={'room-heart-icon' + (room.is_favorite ? ' heart-active' : '')}
                                                             src={(process.env.NODE_ENV === 'development' ? 'http://tonesky.darlane' : '') + '/images/icons/heart.svg'}/>
                                                    </div>
                                                </div>
                                                <a href={room.booking_url}
                                                   className="booking-url-button">Забронировать</a>
                                            </div>
                                        )
                                        : ''
                                }
                            </div>
                        </div>
                    </div>
                }
            </Container>
    );
}));
export default BookingStudioPageIndex;
